// WordPress API utility functions
const API_BASE_URL = 'http://localhost/wordpress/index.php/wp-json/wp/v2';

// Generic fetch function with error handling
const fetchFromWP = async (endpoint) => {
  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('WordPress API Error:', error);
    throw error;
  }
};

// Get all pages
export const getPages = async () => {
  return fetchFromWP('/pages');
};

// Get page by slug
export const getPageBySlug = async (slug) => {
  const pages = await fetchFromWP(`/pages?slug=${slug}`);
  return pages.length > 0 ? pages[0] : null;
};

// Get page by ID
export const getPageById = async (id) => {
  return fetchFromWP(`/pages/${id}`);
};

// Get all posts
export const getPosts = async () => {
  return fetchFromWP('/posts');
};

// Get post by slug
export const getPostBySlug = async (slug) => {
  const posts = await fetchFromWP(`/posts?slug=${slug}`);
  return posts.length > 0 ? posts[0] : null;
};

// Get media by ID
export const getMediaById = async (id) => {
  return fetchFromWP(`/media/${id}`);
};

// Get categories
export const getCategories = async () => {
  return fetchFromWP('/categories');
};

// Search function
export const searchContent = async (query) => {
  return fetchFromWP(`/search?search=${encodeURIComponent(query)}`);
};

// Helper function to get featured image URL
export const getFeaturedImageUrl = async (mediaId) => {
  if (!mediaId) return null;
  
  try {
    const media = await getMediaById(mediaId);
    return media.source_url || null;
  } catch (error) {
    console.error('Error fetching featured image:', error);
    return null;
  }
};

// Helper function to strip HTML tags
export const stripHtml = (html) => {
  const temp = document.createElement('div');
  temp.innerHTML = html;
  return temp.textContent || temp.innerText || '';
};

// Helper function to get excerpt
export const getExcerpt = (content, length = 150) => {
  const stripped = stripHtml(content);
  return stripped.length > length 
    ? stripped.substring(0, length) + '...' 
    : stripped;
};